import MaterialCard from './MaterialCard';
import { MaterialItem } from '../../types/materials';

interface MaterialsSectionProps {
    items: MaterialItem[];
    onView: (item: MaterialItem) => void;
    onDownload: (item: MaterialItem) => void;
}

const MaterialsSection = ({ items, onView, onDownload }: MaterialsSectionProps) => {
    // Nothing to show → the whole section stays out of the DOM (house rule: no empty materials block).
    if (items.length === 0) {
        return null;
    }

    return (
        <div className="materials-section">
            <div className="materials-section__title">Materiallar</div>
            <div className="materials-section__list">
                {items.map((item) => (
                    <MaterialCard key={item.id} item={item} onView={onView} onDownload={onDownload} />
                ))}
            </div>
        </div>
    );
};

export default MaterialsSection;
